import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Desconto, GrupoDesconto } from "./models/desconto";

@Injectable({
  providedIn: 'root'
})

export class DescontoService {

  private environmentUrl: string = '';

  constructor(private httpClient: HttpClient) {
    this.environmentUrl = environment.ApiCore + '/desconto';
  }


  getGruposDesconto() {
    return this.httpClient.get<GrupoDesconto[]>(this.environmentUrl + `/grupodesconto`);
  }

  getDescontos() {    
    return this.httpClient.get<Desconto[]>(this.environmentUrl);
  }

  delDesconto(desconto: Desconto) {
    return this.httpClient.delete(this.environmentUrl + "/" + desconto.idDesconto);
  }

  addDesconto(desconto: Desconto) {
    return this.httpClient.post(this.environmentUrl + "/", desconto);
  }

  updDesconto(desconto: Desconto) {
    return this.httpClient.put(this.environmentUrl + "/", desconto);
  }

}